import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import FillResume from '@/views/Resume/FillResume.vue'
import MyResume from '@/views/User/MyResume.vue'
import TestSurvey from '@/views/User/TestSurvey.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '招聘'
    }
  },
  {
    path: '/fillResume',
    name: 'FillResume',
    component: FillResume,
    meta: {
      title: '填写简历'
    }
  },
  {
    path: '/myResume',
    name: 'MyResume',
    component: MyResume,
    meta: {
      title: '我的简历'
    }
  },
  {
    path: '/testSurvey',
    name: 'TestSurvey',
    component: TestSurvey,
    meta: {
      title: '测试问卷'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta.title === '') {
    document.title = to.meta.title
  }
})
export default router
